<template>
  <blockquote class="quote component">
    <div class="quote__text" v-html="config.quote" v-if="config.quote">
    </div>
    <footer class="quote__cite" v-if="config.cite">{{config.cite}}</footer>
  </blockquote>
</template>

<script>
    export default {
        name: 'Quote',
        props: ["config"]
    }
</script>

<style scoped>
  /*copied from publicera*/
  .quote {
    margin-left: 1rem;
    margin-right: 1rem;
    text-align: center;
    font-style: italic;
  }

  .quote__text {
    font-size: 1.5rem;
  }

  .quote__text p {
    margin-bottom: .75rem;
  }
</style>



// WEBPACK FOOTER //
// src/pages/cms/pageComponents/QuoteComponent.vue